import { type Component } from "solid-js";
import {
  phase,
  chunkCount,
  prompt,
  setPrompt,
  deviceLabel,
} from "../lib/store.ts";

const HUD: Component = () => {
  return (
    <>
      {/* Top-left: model info */}
      <div class="hud hud-tl">
        <div class="stat"><span>MiDashengLM</span></div>
        <div class="stat"><span>{deviceLabel()}</span></div>
        <div class="stat">
          <span>chunks:</span>
          <span class="v">{chunkCount()}</span>
        </div>
        <div class="stat" style={{ "max-width": "220px" }}>
          <span>prompt:</span>
          <span
            class="v"
            style={{
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
            }}
          >
            {prompt()}
          </span>
        </div>
      </div>

      {/* Top-right: live prompt editor + status */}
      <div class="hud hud-tr" style={{ gap: "0.6rem" }}>
        <input
          class="prompt-live"
          type="text"
          value={prompt()}
          spellcheck={false}
          autocomplete="off"
          onChange={(e) => setPrompt(e.currentTarget.value)}
        />
        <span class="conn-label">
          {phase() === "inferring" ? "inferring" : phase()}
        </span>
        <div
          class="dot"
          classList={{
            on: phase() === "recording" || phase() === "ready",
            silence: phase() === "silence",
            inferring: phase() === "inferring",
          }}
        />
      </div>

      {/* Bottom-right: phase */}
      <div class="hud hud-br">
        <div class="stat"><span>{phase()}</span></div>
      </div>
    </>
  );
};

export default HUD;
